// import { color } from "echarts"

const chinaGeoCoordMap = {
  黑龙江: [127.9688, 45.368],
  内蒙古: [110.3467, 41.4899],
  吉林: [125.8154, 44.2584],
  北京市: [116.4551, 40.2539],
  辽宁: [123.1238, 42.1216],
  河北: [114.4995, 38.1006],
  天津: [117.4219, 39.4189],
  山西: [112.3352, 37.9413],
  陕西: [109.1162, 34.2004],
  甘肃: [103.5901, 36.3043],
  宁夏: [106.3586, 38.1775],
  青海: [101.4038, 36.8207],
  新疆: [87.9236, 43.5883],
  西藏: [91.11, 29.97],
  四川: [103.9526, 30.7617],
  重庆: [108.384366, 30.439702],
  山东: [117.1582, 36.8701],
  河南: [113.4668, 34.6234],
  江苏: [118.8062, 31.9208],
  安徽: [117.29, 32.0581],
  湖北: [114.3896, 30.6628],
  浙江: [119.5313, 29.8773],
  福建: [119.4543, 25.9222],
  江西: [116.0046, 28.6633],
  湖南: [113.0823, 28.2568],
  贵州: [106.6992, 26.7682],
  云南: [102.9199, 25.4663],
  广东: [113.12244, 23.009505],
  广西: [108.479, 23.1152],
  海南: [110.3893, 19.8516],
  上海: [121.4648, 31.2891],
  北京: [116.4551, 40.2539],
}

const chinaDatas = [
  [{ name: "北京", value: 0 }],
  [{ name: "宁夏", value: 0 }],
  [{ name: "青海", value: 0 }],
  [{ name: "新疆", value: 0 }],
  [{ name: "西藏", value: 0 }],
  [{ name: "四川", value: 0 }],
  [{ name: "重庆", value: 0 }],
  [{ name: "山东", value: 0 }],
  [{ name: "河南", value: 0 }],
  [{ name: "江苏", value: 0 }]
]

// const convertData = (data) => {
//   const res = []
//   for (let i = 0; i < data.length; i++) {
//     const dataItem = data[i]
//     const fromCoord = [103.9526, 30.7617]
//     const toCoord = chinaGeoCoordMap[dataItem[0].name]
//     if (fromCoord && toCoord) {
//       res.push([
//         {
//           coord: fromCoord,
//           value: "12345689764",
//         },
//         {
//           coord: toCoord,
//         },
//       ])
//     }
//   }
//   console.log(res[0]);
//   return res;
// }

const option = {
  title: {
    text: '全国物流轨迹图',
    left: 10,
    top: 20,
    textStyle: {
      color: '#2ec5d0'
    }
  },
  tooltip: {
    show: true
  },
  geo: {
    map: "china",    // 使用 registerMap 注册的地图名称
    roam: true,      // 是否开启鼠标缩放和平移漫游
    zoom: 1.2,       // 当前视角的缩放比例
    label: {         // 图形上的文本标签
      emphasis: { show: false }
    },
    itemStyle: {     // 地图区域的多边形 图形样式
      // color: "rgba(51, 69, 89, .8)",   // 图形的颜色。              
      areaColor: 'rgba(0,255,255,.02)',
      borderColor: '#00ffff',             // 图形的描边颜色
      borderWidth: 0.3,                   // 描边线宽,为0时无描边
      shadowColor: '#00ffff',
      shadowOffsetX: 0,
      shadowOffsetY: 4,
      shadowBlur: 10,
      emphasis: {                         // 高亮状态下的多边形和标签样式。
        label: false,
        color: "rgba(37, 43, 61, .5)"
      }
    },
    tooltip: {
      show: false
    }
  },
  series: [
    {
      type: "lines",
      name: "订单信息",                 // 系列名称，用于 tooltip 的显示
      zlevel: 2,
      effect: {
        show: true,
        period: 2,                     // 箭头指向速度，值越小速度越快
        trailLength: 0.6,             // 特效尾迹长度[0,1]值越大，尾迹越长重
        symbol: "circle",               // 箭头图标
        symbolSize: 3,                 // 图标大小
        color: '#FFFF99'
      },
      lineStyle: {                     // 线条样式
        
        opacity: 0,                    // 图形透明度
        curveness: 0.1                 // 尾迹线条曲直度
      },
      animationEasing: 'quadraticOut',
      tooltip: {
        show: true,
        backgroundColor: "#FFF",
        borderColor: "#FFF",
        textStyle: {
          color: '#0052FF',
          fontSize: 15
        },
        formatter: params => {
          if (params.componentSubType == "lines") {
            const value = params.data.value
            return `
              <div>订单ID：${value.orderNo}</div>
              <div>发货地：${value.qd}</div>
              <div>收货地：${value.zd}</div>
              <div>订单时间：${value.date}</div>
              `
          }
        },
      },
      // 假数据格式化
      // data: convertData(chinaDatas)
      data: [
        [{ coord: [105.56821, 30.52552] }, { coord: [116.200882, 39.943405] }]
      ]
    },
    {
      type: "effectScatter",
      coordinateSystem: "geo",           // 该系列使用的坐标系
      zlevel: 3,
      symbol: "circle",
      symbolSize: 5,
      itemStyle: { 
        color: "#01fafb"
      },
      // data: chinaDatas.map((dataItem) => {
      //   console.log(chinaGeoCoordMap[dataItem[0].name].concat([dataItem[0].value]))
      //   return {
      //     // name: dataItem[0].name,
      //     value: chinaGeoCoordMap[dataItem[0].name].concat([dataItem[0].value])
      //   }
      // })
      data: []
    }
  ]
}

export default {
  chinaGeoCoordMap,
  chinaDatas,
  option
}
